
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface EmptyEventsCardProps {
  onCreateEvent?: () => void;
}

const EmptyEventsCard = ({ onCreateEvent }: EmptyEventsCardProps) => {
  return (
    <Card className="w-full">
      <CardContent className="flex flex-col items-center justify-center p-8 text-center">
        <div className="rounded-full bg-gray-100 p-3 mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-6 w-6 text-gray-500"
          >
            <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
            <line x1="16" x2="16" y1="2" y2="6" />
            <line x1="8" x2="8" y1="2" y2="6" />
            <line x1="3" x2="21" y1="10" y2="10" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold mb-2">Nincsenek események</h3>
        <p className="text-gray-500 mb-4">
          Jelenleg nincsenek események. Hozzon létre egy új eseményt az események kezelésének megkezdéséhez.
        </p>
        {onCreateEvent && (
          <Button onClick={onCreateEvent}>
            <Plus className="mr-2 h-4 w-4" />
            Új esemény létrehozása
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default EmptyEventsCard;
